var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.14258 0H10.2854V1.71429H5.14258V0Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.71484 1.71423H5.14342V3.42852H1.71484V1.71423Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2852 1.71423H11.9994V3.42852H10.2852V1.71423Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7148 1.71423H17.1434V3.42852H13.7148V1.71423Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.42859H1.71429V6.85716H0V3.42859Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14258 3.42859H8.57115V5.14287H5.14258V3.42859Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.42859H13.7143V5.14287H12V3.42859Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.142 3.42859H18.8563V6.85716H22.2849V8.57145H23.9992V17.1429H22.2849V18.8572H18.8563V22.2857H15.4277V20.5714H17.142V10.2857H15.4277V8.57145H17.142V3.42859Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.71484 6.85718H5.14342V8.57146H3.42913V20.5715H5.14342V22.2857H1.71484V6.85718Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.85718H15.4286V8.57146H12V6.85718Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14258 8.57141H6.85686V10.2857H5.14258V8.57141Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2852 8.57141H11.9994V12H10.2852V8.57141Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85742 10.2858H8.57171V12.0001H6.85742V10.2858Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8574 10.2858H22.286V15.4286H18.8574V10.2858Z",
    fill: "#F4F3EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57227 12H10.2866V13.7143H8.57227V12Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14258 22.2858H15.4283V24.0001H5.14258V22.2858Z",
    fill: "#1A1A1A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPint);
export default __webpack_public_path__ + "static/media/pint.e776101a.svg";
export { ForwardRef as ReactComponent };